import apiClient from './baseApi';

/**
 * API para gestión del resumen corporativo
 */
export const resumenCorporativoApi = {
  /**
   * Obtiene el resumen corporativo para una fecha específica
   * @param {string} fecha - Fecha en formato YYYY-MM-DD (opcional, por defecto hoy)
   * @returns {Promise} - Respuesta de la API con el resumen corporativo
   */
  getResumen: async (fecha = null) => {
    try {
      const params = fecha ? { fecha } : {};
      const response = await apiClient.get('/resumen-corporativo', { params });
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen corporativo:', error);
      throw error;
    }
  },

  /**
   * Obtiene el resumen corporativo por rango de fechas
   * @param {string} fechaInicio - Fecha inicio en formato YYYY-MM-DD
   * @param {string} fechaFin - Fecha fin en formato YYYY-MM-DD
   * @returns {Promise} - Respuesta de la API con el resumen por rango
   */
  getResumenPorRango: async (fechaInicio, fechaFin) => {
    try {
      const response = await apiClient.get('/resumen-corporativo/rango-fechas', {
        params: {
          fecha_inicio: fechaInicio,
          fecha_fin: fechaFin
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error al obtener resumen por rango de fechas:', error);
      throw error;
    }
  }
};

export default resumenCorporativoApi;